import { httpClient } from '../httpClient';
import {
  IMusicEditing,
  CreateMusicEditingRequest,
  MusicEditingQuery,
  PaginatedResponse,
  PaginationQuery,
} from '@packages/global';

/**
 * 用户音乐编辑 API 模块
 */
export class MusicEditingApi {
  /**
   * 分页查询音乐编辑任务列表
   */
  async page(queryData: PaginationQuery<MusicEditingQuery>): Promise<PaginatedResponse<IMusicEditing>> {
    return httpClient.post<PaginatedResponse<IMusicEditing>>('/user/musicEditings/page', queryData);
  }

  /**
   * 创建音乐编辑任务
   */
  async create(data: CreateMusicEditingRequest): Promise<IMusicEditing> {
    return httpClient.post<IMusicEditing>('/user/musicEditings', data);
  }

  /**
   * 获取音乐编辑任务详情
   */
  async get(id: string): Promise<IMusicEditing> {
    return httpClient.get<IMusicEditing>(`/user/musicEditings/${id}`);
  }

  /**
   * 删除音乐编辑任务
   */
  async delete(id: string): Promise<void> {
    return httpClient.delete<void>(`/user/musicEditings/${id}`);
  }

  /**
   * 更新音乐编辑标题
   */
  async updateTitle(id: string, title: string): Promise<void> {
    return httpClient.patch<void>(`/user/musicEditings/${id}/title`, { title });
  }
}

export const musicEditingApi = new MusicEditingApi();
